// 图表加载工具
let g2plotInstance = null
let loadingPromise = null

export async function loadG2Plot () {
  // 如果已经加载过，直接返回
  if (g2plotInstance) {
    return g2plotInstance
  }

  // 如果正在加载中，等待加载完成
  if (loadingPromise) {
    return loadingPromise
  }

  // 开始加载
  loadingPromise = new Promise(async (resolve, reject) => {
    try {
      console.log('开始加载G2Plot库...')

      // 尝试多种加载方式
      let g2plot

      try {
        // 方式1: 直接动态导入
        g2plot = await import('@antv/g2plot')
      } catch (error) {
        console.warn('方式1加载失败，尝试方式2...', error)

        // 方式2: 使用require
        try {
          g2plot = require('@antv/g2plot')
        } catch (error2) {
          console.warn('方式2加载失败，尝试方式3...', error2)

          // 方式3: 从window全局对象获取（如果通过script标签加载）
          if (window.G2Plot) {
            g2plot = window.G2Plot
          } else {
            throw new Error('无法加载G2Plot库，所有方式均失败')
          }
        }
      }

      // 验证加载的对象
      if (!g2plot) {
        throw new Error('G2Plot库加载失败：返回空对象')
      }

      // 验证关键组件
      const requiredComponents = ['Column', 'Line', 'DualAxes']
      for (const component of requiredComponents) {
        if (!g2plot[component]) {
          console.warn(`G2Plot组件 ${component} 未找到`)
        }
      }

      console.log('G2Plot库加载成功', g2plot)
      g2plotInstance = g2plot
      resolve(g2plot)
    } catch (error) {
      console.error('G2Plot库加载失败:', error)
      reject(error)
    }
  })

  return loadingPromise
}

// 获取特定图表组件
export async function getChartComponent (componentName) {
  try {
    const g2plot = await loadG2Plot()
    const component = g2plot[componentName]

    if (!component) {
      throw new Error(`图表组件 ${componentName} 未找到`)
    }

    return component
  } catch (error) {
    console.error(`获取图表组件 ${componentName} 失败:`, error)
    throw error
  }
}

// 预加载图表库
export function preloadG2Plot () {
  loadG2Plot().catch(error => {
    console.warn('预加载G2Plot失败:', error)
  })
}
